import { FileViewCell, RawTextCell } from '@/components/Table/components/Cell'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { ListStatus } from '@/constants/api.constant'
import { Flex, Button } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'

const getTableProfileListColumns = ({ handleToggle, handleAddProfileToAllUsers }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 200,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <Flex w="100%" alignItems={'center'}>
            {original?.status === ListStatus.ACTIVE && (
              <>
                <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100px">
                  <MdDeleteOutline
                    size={24}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleToggle(original._id)
                    }}
                  />
                </Flex>
                <Button
                  colorScheme="teal"
                  onClick={(e) => {
                    e.stopPropagation()

                    handleAddProfileToAllUsers(original._id)
                  }}
                >
                  Add to all users
                </Button>
              </>
            )}
            {original?.status === ListStatus.INACTIVE && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100px">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleToggle(original._id)
                  }}
                />
              </Flex>
            )}
          </Flex>
        )
      },
    }),

    columnHelper.accessor('profileName', {}),
    columnHelper.accessor('tableType', {}),

    columnHelper.accessor('status', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ],
      },
    }),
  ]
}

export default getTableProfileListColumns
